import * as _ from 'lodash';

/**
 * Email model
 * @param email
 *  <fields>
 <field name="EmailID"                    type="long" generateIfNull="true"/>
 <field name="EmailType"                  type="byte" min="0" max="10"/>
 <field name="OperatorID"                 type="long"/>
 <field name="FromFullEmailAddress"       type="text" size="255"/>
 <field name="ToFullEmailAddresses"       type="text" size="255"/>
 <field name="CcFullEmailAddresses"       type="text" size="255"/>
 <field name="BccFullEmailAddresses"      type="text" size="255"/>
 <field name="ReplyTo"                    type="text"/>
 <field name="Subject"                    type="text" size="255"/>
 <field name="Body"                       type="text"/>
 <field name="Html"                       type="text"/>
 <field name="EmailThreadID"              type="long"/>
 <field name="CannedMessageID"              type="long"/>
 <field name="EmailAccountID"             type="long"/>
 <field name="AttachmentCount"            type="integer"/>
 <field name="SentDate"                   type="datetime"/>
 <field name="LastIncomingArrived"                   type="datetime"/>
 <field name="ContentType"                type="text" size="64"/>
 <field name="MessageID"                  type="text" size="255"/>
 <field name="AccountID"                  type="long" useAccountIDIfNull="true"/>
 <field name="BodyCharset"                    type="text"/>
 <field name="HtmlCharset"                    type="text"/>
 <field name="BodyOrigCharset"                    type="text"/>
 <field name="HtmlOrigCharset"                    type="text"/>
 <field name="RedirectID" type="long"/>
 <field name="Headers" type="text"/>
 <field name="Created"                    type="created" allowsUpdates="false"/>
 <field name="Deleted"                    type="datetime"/>
 </fields>
 *
 * @constructor
 */

export class Email {
  static comparator(email1, email2) {
    return email1.EmailID === email2.EmailID;
  }

  static wrap(event) {
    return new Email(event.data);
  }

  static wrapAll(eventList) {
    return _.map(eventList, Email.wrap);
  }

  constructor(chatMessage) {
    _.assign(this, chatMessage);
  }
}

export function factory() {
  return Email;
}
